<template>
  <el-card class="project-card">
    <div class="project-card__title">
      <h2>
        <font-awesome-icon :icon="['fas', 'truck']" class="icon"/>
        {{ project.departure_city }} - {{ project.arrival_city }}
      </h2>
    </div>
    <div class="project-card__body">
      <p>
        <span class="italic">
          {{ $t('home.projectCard.numClient') }} :
        </span>
        <span class="bold">
          {{ project.num_client }}
        </span>
      </p>
      <div>
        <font-awesome-icon :icon="['fas', 'truck-loading']" class="icon"/> :
        <span class="bold">
          {{ project.departure_city }}
          {{ project.departure_date }}
        </span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'truck-loading']" class="icon icon-rotation"/> :
        <span class="bold">
          {{ project.arrival_city}} {{ arrivalDate }}
        </span>
      </div>
      <p>
        <span class="italic">
          {{ $t('home.projectCard.fileCreationDate') }} :
        </span>
        <span class="bold">
          {{ project.creation_date}}
        </span>
      </p>
    </div>
    <div class="project-card__bottom">
      <router-link
        :to="{ name: 'details', params: { id: project.token }}">
        <div class="el-button el-button--primary">
          <span class="el-button--inner">{{ $t('home.projectCard.projectLink') }}</span>
        </div>
      </router-link>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'projectCard',
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    arrivalDate() {
      return this.project.arrival_date || this.$t('home.projectCard.noDate');
    },
  },
};
</script>

<style scoped lang="scss">
  .project-card {
    position: relative;
    height: 400px;
    .italic {
      font-style: italic;
    }
    .bold {
      font-weight: 600;
    }
    .icon-rotation {
      transform: scale(-1, 1);
    }
    &__bottom {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
</style>
